import { useNavigate, useSearchParams } from "react-router-dom";
import { useContextSite } from "../../../context/Context";
import { IClienteAtualizarForm, IClienteDTO } from "../../../types/cliente";
import { Cliente } from "../../../services/Cliente";
import { toast } from "react-toastify";
import { removerCaracteresEspeciais } from "../../../utils/masks";
import { useUserPermissions } from "../../../hooks/useUserPermissions";

export const useClientDetail = () => {
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const navigate = useNavigate();
  const { setIsLoad } = useContextSite();
  const { isAdmin, canResetPassword } = useUserPermissions();

  const shouldShowResetPasswordButton = isAdmin() || canResetPassword();

  function submitForm(data: IClienteDTO) {
    setIsLoad(true);
    const PAYLOAD: IClienteAtualizarForm = {
      ...data,
      telefone: removerCaracteresEspeciais(data.telefone),
      cpfCnpj: removerCaracteresEspeciais(data.cpfCnpj),
      uuid: id,
    };

    Cliente.atualizar(PAYLOAD)
      .then(() => {
        toast.success("Dados atualizados com sucesso");
        setTimeout(() => {
          navigate("/configuracoes/clientes");
        }, 1500);
      })
      .catch(
        ({
          response: {
            data: { mensagem },
          },
        }) => toast.error(mensagem)
      )
      .finally(() => {
        setIsLoad(false);
      });
  }

  function handleResetPassword() {
    setIsLoad(true);
    Cliente.resetPassword({ uuidCliente: id! })
      .then(() => {
        toast.success("Senha redefinida com sucesso");
      })
      .catch(
        ({
          response: {
            data: { mensagem },
          },
        }) => {
          toast.error(mensagem);
        }
      )
      .finally(() => {
        setIsLoad(false);
      });
  }

  return { submitForm, handleResetPassword, shouldShowResetPasswordButton };
};
